// extracted by mini-css-extract-plugin
export default {"collapseContainer":"Lodgings_collapseContainer__14cxE","collapsesContainer":"Lodgings_collapsesContainer__XxUuN","collapse":"Lodgings_collapse__S9Tuv"};